import { useState } from "react";
import { Plus } from "lucide-react";
import { ASSISTANT_ENABLED, ASSISTANT_UNAVAILABLE_TITLE } from "./assistantAvailability";

/**
 * The "Add a page" affordance in the pages rail: gated button → inline form.
 *
 * A new page is authored by the assistant engine, so the whole control follows
 * the assistant's availability — when the engine is not reachable the button
 * stays visible but disabled, rather than accepting a request that would fail
 * after a paid session.
 */
export default function AddPage({ disabled, blockedReason, onSubmit }: {
  /** true while a build or assistant job is already running */
  disabled: boolean;
  /** tooltip explaining why the button is disabled, when it is */
  blockedReason?: string;
  onSubmit: (name: string, purpose: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [purpose, setPurpose] = useState("");

  if (!ASSISTANT_ENABLED) {
    return (
      <button className="editor-add-page" disabled title={ASSISTANT_UNAVAILABLE_TITLE}>
        <Plus size={14} /><span>Add a page</span>
      </button>
    );
  }

  if (!open) {
    return (
      <button className="editor-add-page" onClick={() => setOpen(true)} disabled={disabled} title={blockedReason}>
        <Plus size={14} /><span>Add a page</span>
      </button>
    );
  }

  return (
    <form className="add-page-form" onSubmit={(event) => {
      event.preventDefault();
      if (!name.trim()) return;
      onSubmit(name, purpose);
      setOpen(false);
      setName("");
      setPurpose("");
    }}>
      <label>Page name<input autoFocus value={name} onChange={(event) => setName(event.target.value)} placeholder="e.g. Artists" maxLength={40} /></label>
      <label>What should it cover?<textarea value={purpose} onChange={(event) => setPurpose(event.target.value)} placeholder="Optional — one sentence about the page" maxLength={280} /></label>
      <small>ProtoPal builds it from your real business details and links it in your menu.</small>
      <div className="add-page-actions">
        <button type="submit" className="editor-button primary" disabled={!name.trim() || disabled}>Build page</button>
        <button type="button" className="editor-button" onClick={() => setOpen(false)}>Cancel</button>
      </div>
    </form>
  );
}
